import { render, staticRenderFns } from "./PreviousSalary.vue?vue&type=template&id=be9851b0"
import script from "./PreviousSalary.vue?vue&type=script&lang=js"
export * from "./PreviousSalary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports